import * as React from 'react'
import {
  GenericSelector,
  type SelectorItemT
} from '@frontrow/console/src/components/generic-selector'

type Props<T> = {
  onChangeSelection: (selection: T) => void
  selection: T | undefined | null
  collection: Array<SelectorItemT<T>>
  disabled?: boolean
  className?: string
  id?: string
  dataTest?: string
}

export function Selector<T>(props: Props<T>): React.ReactElement {
  const {id, selection, collection, className, onChangeSelection, disabled, dataTest} = props

  return (
    <GenericSelector
      id={id}
      selection={selection}
      collection={collection}
      className={className}
      onChangeSelection={onChangeSelection}
      disabled={disabled}
      dataTest={dataTest}
    />
  )
}
